import { createGlobalStyle } from "styled-components";

const Neon = require("./NeonFuture.ttf");
const Disco = require("./discol__.ttf");
export default createGlobalStyle`
@font-face {
    font-family: 'Neon';
        src: local('Neon'),
        url(${Neon}) format('opentype');
        font-weight: 300;
        font-style: normal;
}

@font-face {
    font-family: 'Disco';
        src: local('Disco'),
        url(${Disco}) format('opentype');
        font-weight: 300;
        font-style: normal;
}
`;
